import React, { useEffect, useState } from 'react'
import DataTable from '../../../component/data_table/DataTable'
import AddButton from '../../../component/buttons/AddButton';
import { Link, useNavigate } from 'react-router-dom';
import { FilePenLine, Trash2 } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../component/loader/Loader';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { defectListTodo } from '../../../redux/slices/master/defects/DefectList';
import { deleteDefectTodo } from '../../../redux/slices/master/defects/DeleteDefect';
import { Tooltip } from 'react-tooltip';

export default function DefectList() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [bool, setBool] = useState(false)
    const [loading, setLoading] = useState(false)
    const defectList = useSelector(state => state?.defectList?.data?.data)



    const editUser = (data) => {
        navigate('/update-defect', { state: data })
    }

    const deleteUser = (data) => {
        Swal.fire({
            title: "Defect Delete",
            text: 'Are you sure want to delete',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#121136',
            cancelButtonColor: '#EF3D50',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Confirm'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteDefectTodo(data)).then((res) => del_res(res))
            }
        })
    }

    const del_res = (res) => {
        if (res?.payload?.status == 204) {
            setBool(!bool)
            Swal.fire({
                title: 'Defect',
                text: res?.data?.massage,
                icon: 'success',
                confirmButtonText: 'OK'
            })

        } else if (res?.payload?.status == 401) {
            localStorage.clear();
            navigate('/login')
        } else if (res?.payload?.status == 400) {
            toast.error(res?.payload?.data?.messagea?.message, { position: "bottom-right" });
        } else if (res?.payload?.status == 404) {
            toast.error('Not Found', { position: "bottom-right" });
        } else {
            toast.error(res?.payload?.data?.message, { position: "bottom-right" });
        }
    }



    const columnDefs = [
        {
            headerName: 'S.NO',
            maxWidth: 90,
            valueGetter: 'node.rowIndex + 1',
            filter: false,
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false,
        },
        {
            headerName: 'DEFECT',
            field: 'name',
            filter: 'agTextColumnFilter',
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false
        },
        {
            headerName: 'CATEGORY',
            field: 'category_status',
            cellRenderer: params =>
                params?.value === 'critical'
                    ? <span className='badge text-bg-danger' style={{ textTransform: "capitalize" }}>{params?.value}</span> :
                    params?.value === 'noncritical' ?
                        <span className='badge text-bg-success' style={{ textTransform: "capitalize" }}>{params?.value}</span> :
                        <span className='badge text-bg-warning' style={{ textTransform: "capitalize" }}>{params?.value}</span>
            ,
            filter: 'agTextColumnFilter',
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false
        },
        {
            headerName: 'REMARK',
            field: 'remark',
            filter: 'agTextColumnFilter',
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false
        },
        {
            headerName: 'STATUS',
            field: 'status',
            cellRenderer: params =>
                params?.data?.status === 'Active'
                    ? <span className='badge text-bg-success'>Active</span>
                    : <span className='badge text-bg-danger'>Inactive</span>,
            filter: 'agTextColumnFilter',
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false,
        },
        {
            headerName: 'ACTION',
            cellRenderer: params => (
                <div className='d-flex'>
                    <span
                        onClick={() => editUser(params?.data)}
                        data-tooltip-id='edit'
                        data-tooltip-content="Defect Update"
                        data-tooltip-place="bottom"
                    >
                        <FilePenLine className='text-success' size={20} />
                    </span>
                    {/* <span className='ms-2'
                        onClick={() => deleteUser(params?.data?._id)}
                        data-tooltip-id='delete'
                        data-tooltip-content="Defect Delete"
                        data-tooltip-place="bottom"
                    >
                        <Trash2 className='text-danger' size={20} />
                    </span> */}
                    <Tooltip id='edit' className='bg-success tooltip_msg' />
                    <Tooltip id='delete' className='bg-danger tooltip_msg' />
                </div>
            ),
            autoHeight: true,
        }
    ];

    useEffect(() => {
        setLoading(true)
        dispatch(defectListTodo()).then((res) => list_res(res?.payload))
    }, [bool])

    const list_res = (res) => {
        if (res?.status) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className='layout_head d-flex justify-content-between align-items-center mb-3'>
                            <h5>Defect List</h5>
                            <Link to='/add-defect'>   <AddButton label={"Add Defect"} /> </Link>
                        </div>
                        {loading ?
                            <div className='text-center'>
                                <Loader />
                            </div>
                            :
                            <DataTable
                                rowData={defectList}
                                columnDefs={columnDefs}
                                height={'65vh'}
                            />}
                    </div>
                </div>
            </div>
        </>
    )
}
